<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="example-container">
        <div class="list">
            <div v-for="(example, index) in exampleList" :key="example.url" class="item">
                <div class="text" v-html="filterXSS(example.tips)">
                </div>
                <div class="image-wrapper">
                    <div class="name" v-if="example.url">
                        {{ example.title }}
                    </div>
                    <img
                        :src="example.url"
                        v-if="example.url"
                        class="image"
                        @error="onImageError(index)"
                    />
                </div>
            </div>
        </div>
        <sp-button
            type="primary"
            size="large"
            @click="handleClick"
        >
            我知道了
        </sp-button>
    </div>
</template>
<script>
import { Button } from '@ks/sharp-ui';
import { filterXSS } from '../../../utils';

export default {
    name: 'file-example',
    components: {
        SpButton: Button,
    },
    props: {
        exampleData: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            exampleList: this.getFormatData(this.exampleData),
            toolBarStyle: { top: 0 },
        };
    },
    methods: {
        filterXSS(html) {
            return filterXSS(html);
        },
        onImageError(index) {
            this.$set(this.exampleList, index, {
                ...this.exampleList[index],
                url: '',
            });
        },
        getFormatData(data) {
            let res = [];
            try {
                res = JSON.parse(data);
            } catch {
                // do nothing
            }
            return res;
        },
        handleClick() {
            this.$emit('confirm');
        },
    },

};
</script>
<style lang="less" scoped>
.example-container {
  padding: 0 19px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 328px;
.list {
    flex: 1 1;
    width: 100%;
    .item {
    margin-bottom: 12px;
    width: 100%;
    .text {
      color: var(--font-desc, #666);
      white-space: pre-wrap;
      font-size: 15px;
      font-weight: 400;
      line-height: 23px;
      margin-bottom: 8px;
    }
    .image-wrapper {
      position: relative;
      border-radius: 4px;
      .name {
        position: absolute;
        left: 0;
        top: 0;
        padding: 4px 8px;
        border-radius: 4px 0px 4px 0px;
        background: rgba(0, 0, 0, 0.52);
        color: #FFF;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        max-width: 174px;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .image {
        // width: 352px;
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 4px;
      }
    }
  }
}
  button {
    width: 256px;
    margin: 24px 0;
  }
}
</style>